import { addDiastereotopicMissingChirality } from 'openchemlib-utils';
import { buildAssignments, } from './utils/generalAssignment/buildAssignments';
import { checkIDs } from './utils/generalAssignment/checkIDs';
import { getTargetsAndCorrelations } from './utils/generalAssignment/getTargetsAndCorrelations';
import getWorkFlow from './utils/generalAssignment/getWorkFlow';
export async function getAssignments(input, options = {}) {
    const { restrictionByCS = {}, justAssign, minScore = 0.01, maxSolutions = 10, nbAllowedUnAssigned, timeout = 6000, predictionOptions = {}, predictions = {}, correlation: correlationOptions = {}, } = options;
    const { tolerance = { H: 0.2, C: 1 }, useChemicalShiftScore = false, chemicalShiftRestriction = true, } = restrictionByCS;
    const molecule = input.molecule;
    if (!molecule)
        throw new Error('It is needed a molecule to assign');
    molecule.addImplicitHydrogens();
    addDiastereotopicMissingChirality(molecule);
    const spectra = checkIDs(input.spectra);
    const { targets, correlations } = getTargetsAndCorrelations(spectra, correlationOptions);
    const { assignmentOrder } = getWorkFlow(correlations, justAssign);
    const solutions = await buildAssignments({
        restrictionByCS: {
            tolerance,
            useChemicalShiftScore,
            chemicalShiftRestriction,
        },
        spectra,
        molecule,
        timeout,
        minScore,
        maxSolutions,
        assignmentOrder,
        nbAllowedUnAssigned,
        correlations,
        targets,
        predictionOptions,
        predictions,
    });
    return solutions;
}
//# sourceMappingURL=getAssignments.js.map